import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/*

tell tailwind-merge about our custom font sizes so it resolves conflicts properly

otherwise if you have something like:
cn('text-cursed text-black')
it will resolve to 'text-black' since it doesnt' know what to do with the conflicting 'text-cursed', which looks kind of similar.

*/

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        // prettier no wrap
        'text-cursed',
        'text-3xs',
        'text-2xs',
      ],
      'font-weight': [
        // prettier no wrap
        'font-blazeit',
      ],
      'max-width': [
        // prettier no wrap
        'max-w-message-content',
      ],
      rounded: [
        // prettier no wrap
        'rounded-glass',
        'rounded-agent-chat-bubble',
        'rounded-modal',
        'rounded-maybe-glass',
        'rounded-nav',
      ],
      shadow: [
        'shadow-message-bubble',
        'shadow-message-reactions',
        'shadow-button',
        'shadow-form',
        'shadow-modal',
        'shadow-menu',
        'shadow-glass',
      ],
      animate: [
        // prettier no wrap
        'animate-bounce-h',
        'animate-feed-jump-highlight',
        'animate-fade-in-now',
        'animate-fade-in-delayed',
        'animate-progress-indeterminate',
      ],
      ease: [
        // prettier no wrap
        'ease-fluid',
      ],
      'clip-path': [
        // prettier no wrap
        'clip-path-circle',
      ],
      'mask-image': [
        // prettier no wrap
        'workspace-picker-unread-mask',
      ],
      scrollbar: [
        // prettier no wrap
        'scrollbar-hidden',
        'scrollbar-thin',
      ],
      'background-image': [
        // prettier no wrap
        'bg-debug-gradient',
      ],
      'feed-highlight': [
        // prettier no wrap
        'feed-jump-highlight',
      ],
    },
  },
});

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Display-casing for user-typed names (chat titles arrive as typed, e.g. "make a
// spinner"): first letter up, the rest untouched. Apply where a display name is
// DERIVED, not per render site, so every surface showing the name agrees.
export function sentenceCase(value) {
  if (typeof value !== 'string' || value.length === 0) return value;
  return value.charAt(0).toUpperCase() + value.slice(1);
}
